var exports = {
  "kL": "xe564cbfb--8072e3--container",
  "$h": "xe564cbfb--8072e3--closed",
  "Qs": "xe564cbfb--8072e3--content",
  "R_": "xe564cbfb--8072e3--heading",
  "DD": "xe564cbfb--8072e3--title",
  "c5": "xe564cbfb--8072e3--arrow-wrapper",
};

module.exports = exports;
